import { Link } from 'react-router-dom';
import { memberPlans } from '@/mocks/homeData';

export default function MemberSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            会员<span className="text-primary-500">方案</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            选择最适合你的会员套餐，解锁极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {memberPlans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-xl p-5 md:p-6 flex flex-col ${
                plan.highlighted
                  ? 'bg-primary-500 text-background-50 scale-[1.02] shadow-lg'
                  : 'bg-background-50 border border-background-200'
              }`}
            >
              {plan.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                  最受欢迎
                </div>
              )}

              <h3 className={`text-lg font-heading font-semibold mb-3 ${plan.highlighted ? 'text-background-50' : 'text-foreground-900'}`}>
                {plan.name}
              </h3>

              <div className="flex items-baseline gap-1 mb-1">
                <span className={`text-3xl md:text-4xl font-heading font-bold ${plan.highlighted ? 'text-background-50' : 'text-foreground-900'}`}>
                  ¥{plan.price}
                </span>
                <span className={`text-sm ${plan.highlighted ? 'text-background-50/70' : 'text-foreground-500'}`}>
                  /{plan.period}
                </span>
              </div>

              <div className={`text-xs mb-5 ${plan.highlighted ? 'text-background-50/60' : 'text-foreground-400'}`}>
                <span className="line-through">¥{plan.originalPrice}/{plan.period}</span>
                <span className={`ml-1.5 px-1.5 py-0.5 rounded text-xs font-medium ${plan.highlighted ? 'bg-background-50/20 text-background-50' : 'bg-primary-100 text-primary-700'}`}>
                  省¥{Number(plan.originalPrice) - Number(plan.price)}
                </span>
              </div>

              <ul className="space-y-2.5 mb-6 flex-1">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2">
                    <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-background-50' : 'text-primary-500'}`}>
                      <i className="ri-check-line text-sm" />
                    </span>
                    <span className={`text-xs md:text-sm leading-relaxed ${plan.highlighted ? 'text-background-50/85' : 'text-foreground-600'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <Link
                to="/category/tv-series"
                className={`w-full py-2.5 rounded-full text-sm font-semibold text-center transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  plan.highlighted
                    ? 'bg-background-50 text-primary-600 hover:bg-background-100'
                    : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                }`}
              >
                {plan.highlighted ? '立即开通' : '选择方案'}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}